import { createContext, ReactElement, useEffect, useState } from "react";
import { ITokenData } from "../types";
import { useFetch } from "../system/useFetch";

const queryString = window.location.search;
const urlParams = new URLSearchParams(queryString);

interface IContextData {
  authState: ITokenData | null;
}

type IAuthProviderProps = {
  children: ReactElement[] | ReactElement;
};

/*
|---------------------------------------------------------------
| Token Mode. Not used in production
|---------------------------------------------------------------
 */

const AuthContext = createContext<IContextData | null>(null);
const { Provider } = AuthContext;

const AuthProvider = ({ children }: IAuthProviderProps): ReactElement => {
  const [authState, setAuthState] = useState<ITokenData | null>(null);
  const { data } = useFetch<ITokenData>( {
    module: "security",
    query: "login",
    payload: {
      email: urlParams.get("userID"),
      password: null
    }
  });


  useEffect(() => {
    if (data) {
      localStorage.setItem("token", data.token ?? "") ;
      localStorage.setItem("userID", `${data.userInfo?.userID ?? 0}`);
      setAuthState(data);
    }
  }, [data]);

  return (
    <Provider value={{ authState }}>
      {authState && children}
    </Provider>
  );
};

export { AuthContext, AuthProvider };